import axios from 'axios'
import { Message } from 'element-ui'
import CONFIG from './config'
import { getToken, setToken } from '@/utils'
import { Base64 } from 'js-base64'
const options = {}
options.baseURL = CONFIG.baseURL
// 浏览器信息
const navigatorMimeTypes = []
if (navigator && navigator.mimeTypes) {
  for (let i = 0; i < navigator.mimeTypes.length; i++) {
    navigatorMimeTypes.push(navigator.mimeTypes[i].type)
  }
}
const navigatorPlugins = []
if (navigator && navigator.plugins) {
  for (let i = 0; i < navigator.plugins.length; i++) {
    navigatorPlugins.push(navigator.plugins[i].name)
  }
}
const Ext = {
  appName: navigator.appName, // 浏览器正式名称
  appVersion: navigator.appVersion, // 浏览器版本号
  cookieEnabled: navigator.cookieEnabled, // 浏览器是否启用了cookie
  cpuClass: navigator.cpuClass, // cpu等级
  mimeTypes: navigatorMimeTypes, // 浏览器MIME类型
  platform: navigator.platform, // 系统平台
  plugins: navigatorPlugins, // 安装的插件
  userLanguage: navigator.userLanguage, // 用户设置的操作系统语言
  userAgent: navigator.userAgent, // 浏览器属性信息
  screenHeight: window.screen.height, // 屏幕分辨率高度
  screenWidth: window.screen.width, // 屏幕分辨率宽度
  screenColor: window.screen.colorDepth, // 颜色质量
  deviceXdpi: window.screen.deviceXDPI, // 像素
  fontSmoothing: window.screen.fontSmoothingEnabled, // 字体是否平滑
  appCodeName: navigator.appCodeName, // 浏览器内部代码名
  appMinorVersion: navigator.appMinorVersion, // 辅版本号
  language: navigator.language, // 浏览器支持的语言
  online: navigator.onLine, // 浏览器是否处于在线模式
  opsProfile: navigator.opsProfile, // opsProfile
  oscpu: navigator.oscpu, // 浏览器正在运行的操作系统
  product: navigator.product, // 浏览器的产品名
  productSub: navigator.productSub, // 浏览器更多信息
  securityPolicy: navigator.securityPolicy, // 浏览器支持的加密类型
  userProfile: navigator.userProfile, // UserProfile对象
  vender: navigator.vender, // 浏览器厂商名称
  vendorSub: navigator.vendorSub, // 浏览器厂商更多的信息
  systemLanguage: navigator.systemLanguage, // 操作系统支持的默认语言
  javaEnabled: navigator.javaEnabled(), // javaEnabled
  lat: '', // 前定位-纬度
  lng: '' // 当前定位-经度
}

// 公共请求参数
const commonParam = {}
const request = axios.create(options)
// POST 传参序列化
request.interceptors.request.use(
  (config) => {
    config.headers['Source'] = 2
    config.headers['Ext'] = Base64.encode(JSON.stringify(Ext))
    const token = getToken()
    const scope = config.headers['scope']
    if (token) {
      config.headers.token = getToken()
      config.headers.scope = scope || 2
    } else {
      config.headers.scope = 1
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
// 返回状态判断
request.interceptors.response.use(
  (response) => {
    if (response.status === 414) {
      Message({
        message: '数据录入过多，请分批操作!',
        type: 'error',
        duration: 5 * 1000
      })
      return false
    }
    const res = response.data
    if (res.code !== 0) {
      // 3高频访问 1100登录密码错误
      if (res.code === 3) {
        return res
      }
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      if (res.code === 1001) {
        setToken('')
        location.href = '/account/login'
      }
      //没绑定微信
      if (res.code === 10007) {
        setToken('')
        location.href = '/account/codeLogin'
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  (error) => {
    return Promise.reject(error)
  }
)
// export default request
/**
 * @param {String} url [请求的url地址]
 * @param {Object} data [请求时携带的参数]
 */
export function GET(url, data = {}) {
  const params = Object.assign(data, commonParam)
  return new Promise((resolve, reject) => {
    request.get(url, params).then(
      (response) => {
        resolve(response)
      },
      (err) => {
        reject(err)
      }
    )
  })
}
/**
 * @param {String} url [请求的url地址]
 * @param {Object} data [请求时携带的参数]
 */
export function POST(url, data = {}) {
  const params = Object.assign(data, commonParam)
  return new Promise((resolve, reject) => {
    request.post(url, QS.stringify(params)).then(
      (response) => {
        resolve(response)
      },
      (err) => {
        reject(err)
      }
    )
  })
}
/**
 * @param {String} url [请求的url地址]
 * @param {Object} data [请求时携带的参数]
 */
export function PATCH(url, data = {}) {
  const params = Object.assign(data, commonParam)
  return new Promise((resolve, reject) => {
    request.patch(url, QS.stringify(params)).then(
      (response) => {
        resolve(response)
      },
      (err) => {
        reject(err)
      }
    )
  })
}
/**
 * @param {String} url [请求的url地址]
 * @param {Object} data [请求时携带的参数]
 */
export function DELETE(url, data = {}) {
  const params = Object.assign(data, commonParam)
  return new Promise((resolve, reject) => {
    request.delete(url, QS.stringify(params)).then(
      (response) => {
        resolve(response)
      },
      (err) => {
        reject(err)
      }
    )
  })
}
export default request



// WEBPACK FOOTER //
// ./src/api/index.js